import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '@/components/Home.vue';
import About from '@/components/About.vue';
import Contact from '@/components/Contact.vue';

const routes: Array<RouteRecordRaw> = [
  { path: '/', name: 'Home', component: Home, meta: { code: '01', title: 'Overview' } },
  { path: '/about', name: 'About', component: About, meta: { code: '02', title: 'Operator' } },
  { path: '/contact', name: 'Contact', component: Contact, meta: { code: '03', title: 'Contact' } },

  // Retired pages, still live in search indexes. The System page is gone and
  // the Telemetry readings now run inline across the remaining pages.
  { path: '/system', redirect: '/' },
  { path: '/telemetry', redirect: '/' },

  // Legacy paths from the previous site, kept so old links resolve.
  { path: '/meet-the-team', redirect: '/about' },
  { path: '/contact-us', redirect: '/contact' },
  { path: '/demo-site', redirect: '/' },
  { path: '/client-diagnostics', redirect: '/' },
  { path: '/diagnostics', redirect: '/' },

  // "daniil demidov resume" is a query worth owning.
  { path: '/resume', redirect: '/about' },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 };
  },
});

// Every route shared one static title, which is wasted signal on the two pages
// a recruiter is most likely to land on directly.
const BASE_TITLE = 'Dev1 Consulting · Daniil Demidov';
const TITLES: Record<string, string> = {
  Home: `${BASE_TITLE} · Production LLM and Agent Systems`,
  About: `Daniil Demidov · Resume and Service Record · ${BASE_TITLE}`,
  Contact: `Contact · ${BASE_TITLE}`,
};

router.afterEach((to) => {
  const name = typeof to.name === 'string' ? to.name : '';
  document.title = TITLES[name] || TITLES.Home;
});

export default router;
